import React from 'react';
import { LoginType } from '@mm/state/controllers/SessionController';
import { AgencyLayout } from './AgencyLayout/AgencyLayout';
import { InviteLayout } from './InviteLayout/InviteLayout';
import { SmbLayout } from './SmbLayout/SmbLayout';
import { FunnelProLayout } from './FunnelProLayout/FunnelProLayout';
import { BlueLayout } from './BlueLayout/BlueLayout';
import { AmbassadorLanding } from './AffiliateLanding/AmbassadorLanding';
import { WhiteLabelLayout } from './WhiteLabelLayout/WhiteLabelLayout';

type Props = {
  type?: LoginType;
  affiliateId?: string;
  children: any;
  companyId?: number;
  hideTrial?: boolean;
};

export const LoginLayout = ({ type, ...rest }: Props) => {
  switch (type) {
    case LoginType.agency:
      return <AgencyLayout {...rest} />;
    case LoginType.invite:
      return <InviteLayout {...rest} />;
    case LoginType.funnelpro:
      return <FunnelProLayout {...rest} />;
    case LoginType.smb:
      return <SmbLayout {...rest} />;
    case LoginType.ambassador:
      return <AmbassadorLanding {...rest} />;
    case LoginType.whiteLabel:
      return <WhiteLabelLayout {...rest} />;
    default:
      return <BlueLayout type={type} {...rest} />;
  }
};
